export enum TransferInvoicesSelectFilter {
  AccountNumber,
  DebtorNumber,
  DebtorName,
}
